<template>
    <section id="help">
        <div v-for="(item,key) in data" :key="key">
            <h3 class="title">{{item.module}}</h3>
            <ul>
                <li v-for="(info,key) in item.helpContentList" :key="key">
                    <p class="problem" @click="curAnswer(info.id)">{{info.question}}</p>
                    <p class="answer" v-if="info.id == curShow" v-html="info.answer"></p>
                    <i v-if="info.id == curShow"></i>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
    import { fetchHelpData} from '@/common/api/helper';
    export default {
        data(){
            return {
                curShow:-1,
                data: ''
            }
        },
        created(){
            fetchHelpData().then(rep => {
                if (rep.data.code === 0) {
                    this.data = rep.data.data.data
                }
            })
        },
        methods:{
            curAnswer(id){
                this.curShow = id;
            }
        }
    }
</script>

<style  lang="scss">
    @import '../../assets/css/px2rem.scss';
    #help{
        .title{
            font-size: px2rem(16);
            color: #666;
            padding:px2rem(12);
            margin-top: px2rem(13);
        }
        p{
            font-size: px2rem(14);
            padding:px2rem(12);
            line-height: px2rem(20);
            background-color: #fff;
        }
        p.problem{
            font-weight: bold;
            color: #333;
            border-bottom: px2rem(1) solid #eee;
        }
        p.answer{
            color: #666;
            padding-bottom: px2rem(20);
        }
        i{
            display: block;
            height:px2rem(8);
            background-color: #f6f6f6;
        }
    }
</style>